export const routeGenerator = function (env) {
  const protocol = "https";
  const uiSubDomain = "fielddispatch";
  const apiSubDomain = "apiexternal";
  // const temporaryApiSubdomain = process.env.WOW_API_ENV === 'temp' ? 'tempapi' : apiSubDomain;
  const wowDomain = "wideopenwest.com";

  const virtualApp = (env) => {
    const o = {
      prod: "FieldServiceTool",
      blue: "FieldServiceTool",
      green: "FieldServiceToolGreen",
    };

    if (!o.hasOwnProperty(env)) {
      // assumes that all environments will try to have 'FieldServiceTool' as their virtual app.
      return "FieldServiceTool";
    }

    return o[env];
  };

  const apiServiceSegments = {
    orderClose: "OrderCloseApi/api/v1",
    equipment: "Equipment/EquipmentAPI/api/v1",
    scheduling: "Scheduling/SchedulingAPI/api/v1",
    careServiceOrder: "WOW.Care/ServiceOrder/api/v1/workorder",
    careApiAccount: "Enterprise/CareApi/api/v1",
    justAsk: "JustAskApi/api/v1",
    sqc: "Tools/SqcApi/api/v1",
    fstApiCallHandler: "FSTApiCallHandler/api/v1",
    toolsFst: "tools/FieldServiceTool/api/v1",
    techStatus: "Scheduling/SchedulingAPI/api/v1/techstatus",
    uiHost: "/" + virtualApp(env),
    outage: "OutageApi/api/v1",
    houseUpdate: "WOW.BillingSystem/HouseUpdate/api/v1",
    messaging: "Messaging/api/v1",
  };

  const host = ({
    "local": "/api-proxy",
    "local-itouat": "/api-proxy",
    "itodev": protocol + "://" + apiSubDomain + '.' + 'itodev' + "." + wowDomain,
    "itouat": protocol + "://" + apiSubDomain + '.' + 'itouat' + "." + wowDomain,
    "itosit": protocol + "://" + apiSubDomain + '.' + 'itosit' + "." + wowDomain,
    "prod": protocol + '://' + apiSubDomain + '.' + wowDomain
  })[env] || '';

  const uiHost = ({
    "local": "http://localhost:3045",
    "local-itouat": "http://localhost:3045",
    // "local": protocol + "://dev" + uiSubDomain + "." + wowDomain + apiServiceSegments.uiHost,
    "dev": protocol + "://dev" + uiSubDomain + "." + wowDomain + apiServiceSegments.uiHost,
    "itodev": protocol + "://" + uiSubDomain + ".itodev." + wowDomain + apiServiceSegments.uiHost,
    "itouat": protocol + "://" + uiSubDomain + ".itouat." + wowDomain + apiServiceSegments.uiHost,
    "itosit": protocol + "://" + uiSubDomain + ".itosit." + wowDomain + apiServiceSegments.uiHost,
    "prod": protocol + '://' + uiSubDomain + '.' + wowDomain + apiServiceSegments.uiHost
  })[env] || '';

  const itodevAWSGateway = 'svc.itodev.wowinc.com';
  const preprodAWSGateway = 'dev.svc.wowinc.com';
  const itouatAWSGateway = 'svc.itouat.wowinc.com';
  const itositAWSGateway = 'svc.itosit.wowinc.com';
  const prodAWSGateway = 'svc.wowinc.com';

  const awsHost = ({
    'local': protocol + '://' + preprodAWSGateway,
    'local-itouat': protocol + '://' + itouatAWSGateway,
    'itodev': protocol + '://' + itodevAWSGateway,
    'itouat': protocol + '://' + itouatAWSGateway,
    'itosit': protocol + '://' + itositAWSGateway,
    'prod': protocol + '://' + prodAWSGateway
  })[env] || '';

  const awsOutageHost = ({
    'local': 'https://dev.clm.wowinc.com/outage',
    'local-itouat': 'https://clm.itouat.wowinc.com/outage',
    'itodev': 'https://clm.itodev.wowinc.com/outage',
    'itosit': 'https://clm.itosit.wowinc.com/outage',
    'itouat': 'https://clm.itouat.wowinc.com/outage',
    'prod': 'https://prod.clm.wowinc.com/outage'
  })[env] || '';

  return {
    host: host,
    awsEndpoint: awsHost,
    orderCloseService: host + "/" + apiServiceSegments.orderClose,
    equipmentService: host + "/" + apiServiceSegments.equipment,
    schedulingService: host + "/" + apiServiceSegments.scheduling,
    careServiceOrder: host + "/" + apiServiceSegments.careServiceOrder,
    justAskService: host + "/" + apiServiceSegments.justAsk,
    serviceQualityCheck: host + "/" + apiServiceSegments.sqc,
    fstApiCallHandlerService: host + "/" + apiServiceSegments.fstApiCallHandler,
    fstToolsService: host + "/" + apiServiceSegments.toolsFst,
    techStatus: host + "/" + apiServiceSegments.techStatus,
    careApiService: host + "/" + apiServiceSegments.careApiAccount,
    uiSilentRenew: uiHost,
    callBackRoute: uiHost,
    outage: host + "/" + apiServiceSegments.outage,
    outageAWS: awsOutageHost,
    houseUpdate: host + "/" + apiServiceSegments.houseUpdate,
    messaging: host + "/" + apiServiceSegments.messaging,
  };
};

const wowUrls = routeGenerator(process.env.WOW_API_ENV);

export const host = wowUrls.host;

export const USER_CHANNEL_GRANT_APPIAN_URL = `${wowUrls.awsEndpoint}/helpers/activation/grantChannel`;

export const ONE_LOGIN = ({
  'local': 'wowinc.onelogin.com',
  'local-itouat': 'wowinc-nonprod.onelogin.com',
  'itodev': 'wowinc-nonprod.onelogin.com',
  'itouat': 'wowinc-nonprod.onelogin.com',
  'itosit': 'wowinc-nonprod.onelogin.com',
  'prod': 'wowinc.onelogin.com'
})[process.env.WOW_API_ENV] || '';

//Misc
export const UI_CLIENT_ID = ({
  'local': 'f87081e0-6241-0139-bf2a-0a05238aeed3160033',
  'local-itouat': '1fb79740-7397-0139-0a5a-06ef250cda35186933',
  'itodev': '818a3d20-d706-013b-6f38-0a9bcec62ffd186933',
  'itouat': '1fb79740-7397-0139-0a5a-06ef250cda35186933',
  'itosit': 'cc621b50-29ea-013a-93de-02e05dbc6c19186933',
  'prod': '4806a200-625a-0139-3a07-069651a0e2b7160033'
})[process.env.WOW_API_ENV] || '';

//Token Support
export const SILENT_RENEW_REDIRECT = `${wowUrls.uiSilentRenew}/silent_renewindex.html`;
export const AUTH_REDIRECT_URI = `${wowUrls.callBackRoute}/callback`;

//Mobie Retry Logic
export const SET_TECH_STATUS_URL = `${wowUrls.fstApiCallHandlerService}/multicall/techstatuschange`;
export const TECH_STATUS_GET_URL = `${wowUrls.fstApiCallHandlerService}/multicall/techstatuschange`;

//Tech Status
export const SET_TECH_STATUS_READY_URL = `${wowUrls.techStatus}/ready`;
export const SET_TECH_STATUS_IN_ROUTE_URL = `${wowUrls.techStatus}/enroute`;
export const SET_TECH_STATUS_ON_BREAK_URL = `${wowUrls.techStatus}/onBreak`;
export const SET_TECH_STATUS_OFF_BREAK_URL = `${wowUrls.techStatus}/offBreak`;
export const SET_TECH_STATUS_ON_JOB_URL = `${wowUrls.techStatus}/onJob`;
export const SET_TECH_STATUS_UNDO_IN_ROUTE_URL = `${wowUrls.techStatus}/undoEnroute`;
export const SET_TECH_STATUS_UNDO_ON_JOB_URL = `${wowUrls.techStatus}/undoOnJob`;
export const SET_TECH_STATUS_NOT_READY_URL = `${wowUrls.techStatus}/notready`;
export const WORK_ORDER_TRANSFER_URL = `${wowUrls.techStatus}/order-transfer`;

//Scheduling
export const WORKORDER_MY_ROUTE_URL = `${wowUrls.schedulingService}/technician-appointment/myRoute`;
export const WORKORDER_TECH_ROUTE_URL = `${wowUrls.schedulingService}/technician-appointment/techRoute`;
export const WORK_ORDER_BY_ORDER_ID_URL = `${wowUrls.schedulingService}/technician-appointment/appointment`;
export const SERVICE_ORDER_STATUS_URL = `${wowUrls.schedulingService}/technician-appointment/orderStatus`;

//Field ServiceTool Api
export const TECH_GET_INFO_URL = `${wowUrls.fstToolsService}/technicians/info`;
export const TECH_GET_HISTORY_URL = `${wowUrls.fstToolsService}/technicians/fstOrderHistory`;
export const TECH_SEND_TRANSACTION_LOGS_URL = `${wowUrls.fstToolsService}/transaction`;
export const CHARGE_OPTIONS_URL = `${wowUrls.fstToolsService}/servicecharges`;
export const CHARGE_ADD_URL = `${wowUrls.fstToolsService}/servicecharges/add`;
export const CHARGE_UPDATE_URL = `${wowUrls.fstToolsService}/servicecharges/update`;
export const UNNECESSARY_TRUCK_ROLL_URL = `${wowUrls.fstToolsService}/servicecharges/UnnecessaryTruckRoll`;
export const EQUIPMENT_OPTIONS_URL = `${wowUrls.fstToolsService}/additionalequipments`;
export const PROVISIONING_STATUS_URL = `${wowUrls.fstToolsService}/additionalequipments/provisioningStatus`;
export const GET_HOME_VERIFY_URL = `${wowUrls.fstToolsService}/technicians/getHomeVerify`;
export const SET_HOME_VERIFY_URL = `${wowUrls.fstToolsService}/technicians/addHomeVerify`;
export const GET_DIGITAL_CHANNELS_URL = `${wowUrls.fstToolsService}/closeorder/getDigitalChannel`;
export const SEND_ASURION_PLUS_ENROLLMENT = `${wowUrls.fstToolsService}/customer-communications/send/asurionPlusEnrollment`;
export const UNABLE_CLOSE_REASONS_URL = `${wowUrls.fstToolsService}/closeorder/reasons/no-access`;

//Care Work Order
export const WORKORDER_CALL_AHEAD_URL = `${wowUrls.careServiceOrder}/callahead`;
export const WORKORDER_DETAIL_URL = `${wowUrls.careServiceOrder}/details`;
export const WORKORDER_SERVICES_URL = `${wowUrls.careServiceOrder}/services`;
export const WORKORDER_REPEATS_URL = `${wowUrls.careServiceOrder}/getRepeatJobStatusByOrderId`;
export const COMMERCIAL_ORDER_DETAIL_URL = `${wowUrls.careServiceOrder}/commercial`;
export const WORKORDER_HISTORY = `${wowUrls.careServiceOrder}/fstCustomerHistoryReport`;

//Care Account
export const WORKORDER_CUSTOMER_INFO_URL = `${wowUrls.careApiService}/accountDetails/customerinfo`;
export const WORKORDER_CUSTOMER_ADDRESS_URL = `${wowUrls.careApiService}/accountDetails/serviceAddress`;
export const WORKORDER_CUSTOMER_BILLING_URL = `${wowUrls.careApiService}/accountDetails/billing`;
export const WORKORDER_CUSTOMER_COLLECTION_URL = `${wowUrls.careApiService}/accountDetails/collectionstatus`;
export const UPDATE_CUSTOMER_EMAIL_URL = `${wowUrls.careApiService}/accountDetails/updatecustomeremail`;
export const PACKAGE_DETAIL_URL = `${wowUrls.careApiService}/accountDetails/package`;
export const ACTIVE_SERVICES_URL = `${wowUrls.careApiService}/accountDetails/activeServices`;
export const NETWORK_DETAIL_URL = `${wowUrls.careApiService}/addressDetails`;
export const ACCOUNT_MEMO_DETAIL_URL = `${wowUrls.careApiService}/accountDetails/customermemos`;
export const ACCOUNT_OTHER_ATTR_URL = `${wowUrls.careApiService}/accountDetails/other-attributes`;
export const UPDATE_EMAIL_CIC = `${wowUrls.careApiService}/accountDetails/updateloginemail`;

//Equipment
export const HOUSE_EQUIPMENT_DETAILS_URL = `${wowUrls.equipmentService}/equipment/houseEquipmentList`;
export const EQUIPMENT_DETAIL_URL = `${wowUrls.equipmentService}/equipment`;
export const EQUIPMENT_HIT_URL = `${wowUrls.equipmentService}/equipment/hit`;
export const EQUIPMENT_BALANCING_HIT_URL = `${wowUrls.equipmentService}/equipment/BalancingHit`;
export const EQUIPMENT_REFRESH_HIT_URL = `${wowUrls.equipmentService}/equipment/refreshHit`;
export const UNPAIR_PAIR_URL = `${wowUrls.equipmentService}/equipment/unpairPair`;
export const TECH_GET_INVENTORY_URL = `${wowUrls.equipmentService}/inventory`;
export const TECH_SEARCH_INVENTORY_URL = `${wowUrls.equipmentService}/inventory/search`;
export const TECH_TRANSFER_INVENTORY_URL = `${wowUrls.equipmentService}/inventory/transfer`;
export const EQUIPMENT_ADD_BY_SERIAL_URL = `${wowUrls.equipmentService}/equipment/addBySerialNumber`;

const useNodeOutageLegacyApi =
  {
    local: false,
    itodev: false,
    itosit: false,
    itouat: false,
    prod: false,
  }[process.env.WOW_API_ENV] === true;

// Node Outage
export const USE_WORKORDER_OUTAGES_LEGACY_API = useNodeOutageLegacyApi;
export const WORKORDER_OUTAGES_URL = `${wowUrls.outageAWS}/outage`;
export const WORKORDER_OUTAGES_LEGACY_URL = `${wowUrls.outage}/nodeoutage`;

export const TAG_UPDATE_URL = `${wowUrls.houseUpdate}/houseupdate`;

//Api External Messaging
export const USER_CHANNEL_GRANT_URL = `${wowUrls.messaging}/message/grant-user-channel`;
export const GET_TOKEN_URL = `${wowUrls.messaging}/message/get-token`;

//Just Ask
export const JUST_ASK_BY_JOB_URL = `${wowUrls.justAskService}/justAsk/myList`;
export const JUST_ASK_ADD_URL = `${wowUrls.justAskService}/justAsk`;
export const JUST_ASK_UPDATE_URL = `${wowUrls.justAskService}/justAsk/byID`;

//SQC
export const SQC_GENERATE_URL = `${wowUrls.serviceQualityCheck}/serviceQualityCheck/GetModem`;
export const SQC_RETRIEVE_URL = `${wowUrls.serviceQualityCheck}/serviceQualityCheck/RetrieveSqc/`;

//Close Order
export const CLOSE_CODES_URL = `${wowUrls.orderCloseService}/closeCode/AllowedCloseCodes`;
export const CLOSE_VALIDATION_URL = `${wowUrls.orderCloseService}/close/validation`;
export const CLOSE_REQUEST_ADD_URL = `${wowUrls.orderCloseService}/close`;
export const CUSTOMER_OUTLET_OPTIMIZATION_URL = `${wowUrls.orderCloseService}/outletOptimization`;

//Close Order Long Running Logic
export const CLOSE_ORDER_START_URL = `${wowUrls.fstApiCallHandlerService}/singlecall/closeorderstart`;
export const SET_DELIVERY_PROOF_URL = `${wowUrls.fstToolsService}/closeOrder/proofOfDelivery/submit`;

export const API_TIMEOUT = 180000;

export const awsGatewayBase = wowUrls.awsEndpoint;

// wow-api-gateway
export const UPDATE_CUSTOMER_EMAIL_ICOMS_URL = `${awsGatewayBase}/user/userinfo`;
export const PIN_RESET_URL = `${awsGatewayBase}/service/video/pin`;

//signal levels flag
export const BYPASS_SIGNAL_LEVELS = true;

export const ASURION_ENROLL_FLAG =
  {
    local: true,
    itodev: true,
    itouat: true,
    itosit: true,
    prod: true,
  }[process.env.WOW_API_ENV] || "";

// NICE Chat script URL
export const NICE_CHAT_URL = 'https://web-modules-de-na1.niceincontact.com/loader/1/loader.js';

// NICE Chat configuration by environment
export const NICE_CHAT_PORT = ({
  'local': 3674,
  'itodev': 3674,
  'itouat': 3674,
  'itosit': 3674,
  'prod': 3674
})[process.env.WOW_API_ENV] || '';

export const NICE_CHAT_ID = ({
  'local': 'chat_b3d3f3a5-b440-4a90-a9a8-328fc866a892',
  'itodev': 'chat_b3d3f3a5-b440-4a90-a9a8-328fc866a892',
  'itouat': 'chat_b3d3f3a5-b440-4a90-a9a8-328fc866a892',
  'itosit': 'chat_b3d3f3a5-b440-4a90-a9a8-328fc866a892',
  'prod': 'chat_b3d3f3a5-b440-4a90-a9a8-328fc866a892'
})[process.env.WOW_API_ENV] || '';

export const chatUrl = '/FieldServiceTool/chat?'

//TMF688 event subscription
export const RESOURCE_STATE_CHANGE_URL = ({
  "local": "https://microservices.itodev.wowinc.com/tmf-api/event/v4/topic/5ffb6ffe-aa70-405d-8af4-a96ab6a10d7b/hub",
  "local-itouat": "https://microservices.itouat.wowinc.com/tmf-api/event/v4/topic/5ffb6ffe-aa70-405d-8af4-a96ab6a10d7b/hub",
  "itodev": "https://microservices.itodev.wowinc.com/tmf-api/event/v4/topic/5ffb6ffe-aa70-405d-8af4-a96ab6a10d7b/hub",
  "itouat": "https://microservices.itouat.wowinc.com/tmf-api/event/v4/topic/5ffb6ffe-aa70-405d-8af4-a96ab6a10d7b/hub",
  "itosit": "https://microservices.itosit.wowinc.com/tmf-api/event/v4/topic/5ffb6ffe-aa70-405d-8af4-a96ab6a10d7b/hub",
  "prod": "https://microservices.wowinc.com/tmf-api/event/v4/topic/5ffb6ffe-aa70-405d-8af4-a96ab6a10d7b/hub"
})[process.env.WOW_API_ENV] || '';

//FST API callback
export const FST_PROVISIONING_CALLBACK_URL = `${wowUrls.fstToolsService}/additionalequipments/provisioning/callback`;


// WEBPACK FOOTER //
// ./src/constants/apiUrls.js